import React from 'react';
import { Link } from 'react-router-dom';
import { Space, Tag, Tooltip } from 'antd';
import dayjs from 'dayjs';
import PRZText from '../../../Common/UI/PRZText';

const ListScreenKeys = ({
  documentData, isEstimate, user,
}) => {
  const record = documentData;

  const colorArray = ['blue', 'red', 'geekblue', 'green', 'volcano', 'orange', 'cyan', 'purple', 'blue', 'red', 'geekblue', 'green', 'volcano', 'orange', 'cyan', 'purple'];

  const estimateData = [
    {
      label: 'Items',
      value: record?.line_count || 0,
    },
    {
      label: 'Created Date',
      value: (
        <React.Fragment>
          <div className="column-date">
            {dayjs(record?.created_at).format('DD/MM/YYYY')}
          </div>
          <PRZText text={(record?.created_by_info ? `${record?.created_by_info.first_name} ${record?.created_by_info.last_name}` : 'Unknown')} className="table-subscript" />
        </React.Fragment>
      ),
    },
    {
      label: 'Labels',
      value: record?.tags ? (
        <Space size={[0, 2]} wrap>
          {record?.tags?.map((tag, index) => (
            <Tag
              key={index}
              color={colorArray[index]}
              style={{
                fontSize: '11px',
                margin: '0 2px',
              }}
            >
              {tag}
            </Tag>
          ))}
        </Space>
      ) : '-',
    },

  ];

  const salesOrderData = [
    {
      label: 'Linked MO',
      value: record?.mo_number || '-',
    },
    {
      label: 'Shopify #',
      value: user?.user_tenants?.find((item) => item?.tenant_id === record?.tenant_id)?.shopify_location_id ? (
        <div>
          {(record?.shopify_order_id)
            ? (
              <Tooltip
                title={`Order placed on ${dayjs(record?.shopify_created_at).format('DD/MM/YYYY hh:mm A')}`}
                overlayClassName="font-12"
                placement="topRight"
              >
                <a
                  href={`https://admin.shopify.com/store/${record?.shopify_shop_name?.split('.')?.[0]}/orders/${record?.shopify_order_id}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  {record?.shopify_order_number}
                </a>
              </Tooltip>
            )
            : '-'}
        </div>
      ) : '-',
    },
    {
      label: 'Shopify Source',
      value: record?.order_client_source?.source || '-',
    },
    {
      label: 'Linked MRP',
      value: record?.mrp_id ? (
        <Link
          // to={`/production/planning/v2/view/${record?.mrp_id}`}
          // target="_blank"
        >
          {record?.mrp_number}
        </Link>
      ) : '-',
    },
    {
      label: 'Linked MR',
      value: record?.linked_prs ? record?.linked_prs?.map((linkedPr) => (
        <Link
          style={{ display: 'block' }}
          key={linkedPr?.pr_number}
          // to={`/purchase/purchase-request/view/${linkedPr?.purchase_requisition_id}`}
          // target="_blank"
        >
          {linkedPr?.pr_number}
        </Link>
      )) : '-',
    },
  ];

  return isEstimate ? estimateData : [...estimateData, ...salesOrderData];
};

export { ListScreenKeys };
